import React from 'react'

export default function Elipse({ fillcolor = 'currentColor', ...props }) {
  return (
    <svg {...props} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="4" r="4" fill={fillcolor} />
    </svg>
  )
}
